import { Moment } from 'moment';

export const getDays = (startDate: Moment, noOfDays = 7): Moment[] =>
  [...Array(noOfDays)].map((_, index) => startDate.clone().add(index, 'day'));
